import agent from "../../services/agent"
import moment from 'moment'
import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
  SOCIAL_LOGIN,
  FORM_LOGIN,
  SET_CURRENT_PROFILE,
  LOGIN_USER_SUCCESS,
  USER_LOGOUT,
  SET_FORGOT_PASSWORD_CONFIRMATION_STATUS,
  LOGIN_PENDING,
  LOGIN_PENDING_ERROR,
  LOGIN_PENDING_SUCCESS,
  LOGIN_ERROR,
  CLEAR_LOGIN_ERROR,
  ENABLE_USER_ERROR,
  ENABLE_USER_PENDING,
  ENABLE_USER_PENDING_SUCCESS,
  CLEAR_ENABLE_USER_ERROR,
  ENABLE_USER_PENDING_ERROR,
  FORGOT_PASSWORD_FORM,
  RESET_PASSWORD_FORM,
  FORM_REGISTER,
  SET_IS_LOADING,
  CLEAR_FORM_LOGIN,
  SUCCESS_MESSAGE,
  CLEAR_SUCCESS_MESSAGE,
  SET_FORGOT_PASSWORD_PENDING,
  RESET_PASSWORD_PENDING,
  CLEAR_RESET_PASSWORD_PENDING,
  REDIRECT_TO_LOGIN,
} from "./actionTypes"
import { showSnackbarStatus } from "../../snackbar/actions"
import { clearForm } from "../../form/actions"

export const loginUser = (user, history) => {
  return {
    type: LOGIN_USER,
    payload: { user, history },
  }
}

export const loginSuccess = user => {
  return {
    type: LOGIN_SUCCESS,
    payload: user,
  }
}

export const logoutUsers = history => {
  return {
    type: LOGOUT_USER,
    payload: { history },
  }
}

export const logoutUserSuccess = () => {
  return {
    type: LOGOUT_USER_SUCCESS,
    payload: {},
  }
}

export const apiError = error => {
  return {
    type: API_ERROR,
    payload: error,
  }
}

export const socialLogin = (data, history, type) => {
  return {
    type: SOCIAL_LOGIN,
    payload: { data, history, type },
  }
}

export const setTokenDetails = (authData) => {
  const { access_token, expires_in, token_type } = authData;
  const expires = moment().unix() + expires_in;
  localStorage.setItem("token", access_token);
  localStorage.setItem("expires_in", expires);
  localStorage.setItem("token_type", token_type);
};

export const formLogin = (form) => ({
  type: FORM_LOGIN,
  payload: { form }
})
export const clearFormLogin = (form) => ({
  type: CLEAR_FORM_LOGIN,
  payload: { form }
})

export const registerForm = (formRegister) => ({
  type: FORM_REGISTER,
  payload: { formRegister }
})


export const forgotPasswordForm = (formforgot) => ({
  type: FORGOT_PASSWORD_FORM,
  payload: { formforgot }
})

export const resetPasswordForm = (formReset) => ({
  type: RESET_PASSWORD_FORM,
  payload: { formReset }
})

export const loginUserSuccess = (email, token, expires) => ({
  type: LOGIN_USER_SUCCESS,
  payload: { email, token, expires },
})

export const loginUserPending = () => ({
  type: LOGIN_PENDING,
});

export const loginUserPendingError = () => ({
  type: LOGIN_PENDING_ERROR,
});

export const loginUserPendingSuccess = () => ({
  type: LOGIN_PENDING_SUCCESS,
});

export const loginUserError = (errorMessage) => ({
  type: LOGIN_ERROR,
  payload: { errorMessage },
});

export const clearLoginUserError = () => ({
  type: CLEAR_LOGIN_ERROR,
});

export const enableUserError = (errorMessage) => ({
  type: ENABLE_USER_ERROR,
  payload: { errorMessage },
});

export const enableUserPending = () => ({
  type: ENABLE_USER_PENDING,
});

export const enableUserPendingSuccess = (result) => ({
  type: ENABLE_USER_PENDING_SUCCESS,
  payload: { result }
});
export const restPasswordPending = () => ({
  type: RESET_PASSWORD_PENDING,
});
export const clearResetPasswordPending = () => ({
  type: CLEAR_RESET_PASSWORD_PENDING,
});
export const redirectToLogin = () => ({
  type: REDIRECT_TO_LOGIN,
});

export const clearEnableUserError = () => ({
  type: CLEAR_ENABLE_USER_ERROR,
});

export const enableUserPendingError = () => ({
  type: ENABLE_USER_PENDING_ERROR,
});

export const logoutUser = () => (dispatch) => {
  dispatch({ type: USER_LOGOUT });
};

const setCurrentProfile = (currentProfile) => ({
  type: SET_CURRENT_PROFILE,
  payload: { currentProfile },
});

export const setIsLoading = (isloading) => ({
  type: SET_IS_LOADING,
  payload: { isloading },
});

export const successMessage = (result) => ({
  type: SUCCESS_MESSAGE,
  payload: { result },
});

export const clearSuccessMessage = () => ({
  type: CLEAR_SUCCESS_MESSAGE,
});

export const setForgotPasswordPending = () => ({
  type: SET_FORGOT_PASSWORD_PENDING,
});


export const userLogin = () => (dispatch, getState) => {
  const currentState = getState();
  const { login } = currentState;
  const { form } = login || {};
  const { formAddLogin } = form || {};
  if (!formAddLogin) {
    dispatch(loginUserError("Please fill required details."));
    return;
  }

  // eslint-disable-next-line no-undef
  dispatch(loginUserPending());
  dispatch(clearLoginUserError());
  agent.Auth.login(formAddLogin.username, formAddLogin.password)
    .then((authData) => {
      setTokenDetails(authData);
      const { access_token, expires_in } = authData;
      agent.Auth.getCurrentUser(access_token)
        .then((currentUser) => {
          dispatch(loginUserPendingSuccess());
          dispatch(setCurrentProfile(currentUser));
          dispatch(loginUserSuccess(currentUser.email, access_token, expires_in));
          dispatch(setIsLoading(false))
        })

    })
    .catch((err) => {
      dispatch(loginUserPendingError());
      if (err && err.response) {
        const { error } = err.response.body;
        dispatch(loginUserError(error));
        dispatch(setIsLoading(true))
      }
      else {
        const message = "Network Error";
        dispatch(loginUserError(message));
        dispatch(setIsLoading(true));
        console.log("User login server error", err);
      }
    });
}

export const setForgotPasswordConfirmationStatus = (confirmationStatus) => ({
  type: SET_FORGOT_PASSWORD_CONFIRMATION_STATUS,
  payload: { confirmationStatus },
});


export const enableUserAccount = (code) => (dispatch, getState) => {
  const currentState = getState();
  const { form } = currentState && currentState.form;
  const { formAddPassword } = form || {};
  if (!formAddPassword) {
    dispatch(enableUserError("Please fill required details."));
    return;
  }
  dispatch(enableUserPending());
  agent.Auth.enableAccount(formAddPassword, code)
    .then((result) => {
      // dispatch(clearEnableUserError());
      dispatch(userLogin());
      dispatch(enableUserPendingSuccess(result));
      // dispatch(showSnackbarStatus("Successfully assigned password to" + result));
    })
    .catch((err) => {
      dispatch(enableUserPendingError());
      if (err && err.response) {
        const { message } = err.response.body;
        dispatch(enableUserError(message));
        return;
      }
      console.log("enable user server error", err);
      dispatch(enableUserError(null));
      dispatch(clearForm());
      dispatch(showSnackbarStatus("Something went wrong. Please try again later"));
    });
};

export const forgotPassword = (email) => (dispatch) => {
  dispatch(setForgotPasswordConfirmationStatus("INPROGRESS"));
  dispatch(setForgotPasswordPending());
  agent.Auth.forgotPassword(email)
    .then((result) => {
      dispatch(successMessage(result));
      dispatch(setForgotPasswordConfirmationStatus("EMAIL_SENT"));
    })
    .catch((err) => {
      dispatch(setForgotPasswordConfirmationStatus("INVALID_EMAIL"));
      if (err && err.response) {
        const { message } = err.response.body;
        dispatch(successMessage(message));
        return;
      }
      else {
        dispatch(successMessage("Network Error"));
      }
    });
};

export const resetPassword = (code) => (dispatch, getState) => {
  const currentState = getState();
  const { login } = currentState;
  const { formReset } = login;

  if (!formReset) {
    dispatch(enableUserError("Please fill required details."));
    return;
  }
  dispatch(restPasswordPending());
  agent.Auth.resetPassword(formReset, code)
    .then((result) => {
      dispatch(clearEnableUserError());
      dispatch(clearResetPasswordPending());
      // dispatch(redirectToLogin());
      dispatch(enableUserPendingSuccess(result));
      dispatch(formLogin({
        username: result,
        password: formReset.password,
      }));
      dispatch(userLogin());
      // dispatch(clearForm());
    })
    .catch((err) => {
      dispatch(enableUserPendingError());
      dispatch(clearResetPasswordPending());
      if (err && err.response) {
        const { message } = err.response.body;
        dispatch(enableUserError(message));
        return;
      }
      else {
        dispatch(enableUserError("Network Error"));
      }
      console.log("reset password error", err);
      // dispatch(clearForm());
      dispatch(showSnackbarStatus("Something went wrong. Please try again later"));
    });
};
